

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { LocationFilters } from 'model';


export function useLocationRoleService(
  authUserId:           string | null | undefined,
  userId:               string | null | undefined,
  parentId:             string | undefined,
  search:               string,
  currentPage:          number,
  isSubmitting:         boolean,
  hasError:             boolean,
  fetch:                (authUserId: string, currentUserId: string, parentId: string | undefined, page: number, search: string, filters: LocationFilters) => void,
  reinitPageCount:      () => void,
  updateSearch:         (search: string) => void,
  successCallback?:     () => void,
): void {

  useEffect(() => {
    return function cleanup() {
      reinitPageCount();
      updateSearch('');
    };
  }, [parentId]);

  const searchValue = parentId === undefined ? search : '';
  useEffect(() => {
    if (authUserId && userId && !isSubmitting && !hasError) {
      if (successCallback) {
        successCallback();
      }
      fetch(authUserId, userId, parentId, currentPage, searchValue, {});
    }
  }, [isSubmitting, userId, parentId, currentPage, searchValue]);
}
